module.exports = __webpack_public_path__ + "img/error-dark.a9c97dc0.svg";